import { render } from "./ComplexView.vue?vue&type=template&id=ae701518"
import script from "./ComplexView.vue?vue&type=script&lang=js"
export * from "./ComplexView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__